export default "encryptingFile = Encrypting...\ndecryptingFile = Decrypting\n\n## Send version 2 strings\n\n"